import React, { Component } from "react";

class MusicOverview extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center"
        }}
        className="music-overview"
      >
        <h2 style={{ margin: "2rem 0" }}>English Motets (growing) Catalog</h2>
        <iframe
          className="catalog"
          width="70%"
          height="800"
          title="Overview of English Motets Catalog"
          src="https://docs.google.com/document/d/e/2PACX-1vR-ieHIuRR5MDOUoZjViaFt9XZhyG0eSNRTl8WEhloEHH0n8YzT7FTdv0S8cmHJ0uymU9SrKNLv5v5F/pub?embedded=true"
        />
      </div>
    );
  }
}

export default MusicOverview;



// WEBPACK FOOTER //
// ./src/components/MusicOverview.js